import React from 'react';
import theme from './BuyerDashboardDeadlines.module.scss';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { Trans } from '@lingui/react/macro';
import { differenceInCalendarDays } from 'date-fns';
import { CustomLink } from '@/components/navigation';
import { orderBy } from 'lodash-es';
import { ProjectFeature, ProjectFeatureMode } from '@/types';
import { DashboardDataCard, InfoIconWithTooltip } from '@ygtechnologies/bygr-frontend-component-library';
interface BuyerDashboardDeadlinesProps {}

const BuyerDashboardDeadlines: React.FC<BuyerDashboardDeadlinesProps> = () => {
    const deadlines = useSelector((state: IState) => state.buyer.projectData!.deadlines);
    const features = useSelector((state: IState) => state.buyer.projectData!.features);
    const optionsEnabled = features?.some(
        (x) => x.feature === ProjectFeature.Options && x.mode === ProjectFeatureMode.Enabled
    );
    const sortedBeforeDeadlines = orderBy(
        deadlines.filter((x) => differenceInCalendarDays(new Date(x.deadline), Date.now()) >= 0),
        'deadline'
    );
    const sortedAfterDeadlines = orderBy(
        deadlines.filter((x) => differenceInCalendarDays(new Date(x.deadline), Date.now()) < 0),
        'deadline'
    ).reverse();

    const sortedDeadlines = sortedBeforeDeadlines.concat(sortedAfterDeadlines);
    return (
        <div className={theme.gridContainer}>
            {sortedDeadlines.length > 0 && (
                <div className={theme.deadlineAlignment}>
                    <Trans>Your deadlines</Trans>
                </div>
            )}
            {sortedDeadlines.map((dl) => {
                const days = differenceInCalendarDays(new Date(dl.deadline), Date.now());
                return (
                    <DashboardDataCard key={dl.id} loading={!deadlines} className={theme.dashboardCards}>
                        <div className={theme.deadlineContainer}>
                            <div className={theme.deadlineHeader}>
                                {dl.hasOptionsAttached && optionsEnabled ? (
                                    <CustomLink to={`/options/${dl.id}`}>{dl.name}</CustomLink>
                                ) : (
                                    <span className={theme.leftAlign}>{dl.name}</span>
                                )}
                                {dl.description && <InfoIconWithTooltip content={dl.description} />}
                            </div>

                            <div className={theme.daysContainer}>
                                {days === 0 ? (
                                    <Trans>Today</Trans>
                                ) : (
                                    <div className={days < 0 ? theme.expiredDeadlineText : ''}>
                                        {days}&nbsp;
                                        <Trans>Days</Trans>
                                    </div>
                                )}
                            </div>
                        </div>
                    </DashboardDataCard>
                );
            })}
        </div>
    );
};

export default BuyerDashboardDeadlines;
